<template>
  <div class="main-container">
    <ModalSelectMedia @updated="selectImage"/>
    <div class="begin-header">
      <h2>HRモンスターへようこそ</h2>
      <p>
        この度はご導入いただきありがとうございます。<br>
        初めてご使用される方向けに<span style="color: red; font-weight: 600;">カンタン導入</span>をご用意しています。<br>
        用途別にHRモンスターの機能のご活用ができます。
      </p>
    </div>
    <div class="begin-main">
      <h1>STEP{{step+1}}：{{titleLists[step]}}</h1>
      <template v-if="step === 0">
        <div class="chatbot-card" v-for="(c, idx) in cards" :key="idx + '-cards'">
          <h2>{{c.title}}</h2>
          <img class="card-image" :src="c.img"/>
          <p class="desc">{{c.desc}}</p>
          <button class="button is-primary" @click="step=1; selectIndex=idx">作成する</button>
        </div>
      </template>
      <template v-if="step === 1">
        <div class="input-box">
          <template v-if="selectIndex < 3">
            <h2>ロボ名を入力してください</h2>
            <div style="padding: 8px;">
              <input class="input" v-model="roboName"/>
            </div>
            <h2>取得したい情報を次の中から選択してください（複数選択可、お名前は必須入力になります。）</h2>
            <div style="display: flex; padding: 8px;">
              <b-checkbox v-model="selectCol" v-for="(check, idx) in checkBox" :native-value="check" :key="idx + 'ch'" :disabled="idx === 0">
                {{check}}
              </b-checkbox>
            </div>
            <h2>上記以外で質問した項目があれば入力してください（５つまで可）</h2>
            <div style="padding: 8px;" v-for="(question, idx) in questions" :key="idx">
              <div style="display: flex;">
                <input class="input" v-model="question.text"/>
                <button class="button" @click="addQuestion(idx)">+ 追加</button>
                <button class="button -left-4px" @click="delQuestion(idx)">- 削除</button>
              </div>
            </div>
            </template>
          <template v-else>
            <h2>スカウト名を入力してください</h2>
            <div style="padding: 8px;">
              <input class="input" v-model="tempScout.name"/>
            </div>
            <h2>画像をアップロード後、選択してください</h2>
            <div style="padding: 8px; max-width: 320px;">
              <img style="width: 100%; object-fit: scale-down;" :src="getImage(tempScout.scout_image_ref, tempScout.store_image)"/>
              <button class="button is-small" style="margin-left: 10px; width: calc(100% - 100px);" @click="openSelectModal">メディア倉庫から選択</button>
            </div>
            <h2>スカウト内容を入力してください</h2>
            <div style="padding: 8px;">
              <textarea class="input is-small" placeholder="内容" v-model="tempScout.content" style="height: 128px;"/>
            </div>
          </template>
          <button class="button is-primary -top-8px" @click="nextStepNowTwo()">次へ進む</button>
        </div>
      </template>
      <template v-if="step === 2">
        <div class="input-box">
          <template v-if="selectIndex < 3">
            <h2>設置したいホームページのURLを入力してください<br>（URLのリンクで共有する場合は記載不要です）</h2>
            <p>
              ※登録後実際にホームページに設置する場合は「設定」＞「アプリアイコン」より<br>
              スクリプトコードを取得しホームページのソースコードに貼り付けてください。<br>
              詳細が不明な場合は本カンタン作成終了後、ウェブセミナーもご案内しておりますので<br>
              ご参加頂けますと幸いでございます。
            </p>
            <div style="display: flex; padding: 8px;" v-for="(url, idx) in urls" :key="idx">
              <div style="display: flex;">
                <input class="input" v-model="url.text"/>
                <button class="button" @click="addURL(idx)">+ 追加</button>
                <button class="button -left-4px" @click="delURL(idx)">- 削除</button>
              </div>
            </div>
          </template>
          <template v-else>
            <h2>スカウト設定を選んでください</h2>
            <p>
              ※登録後実際にホームページにスカウトを設置する場合は「設定」＞「アプリアイコン」より<br>
              スクリプトコードを取得しホームページのソースコードに貼り付けてください。<br>
              詳細が不明な場合は本カンタン作成終了後、ウェブセミナーもご案内しておりますので<br>
              ご参加頂けますと幸いでございます。
            </p>
            <div style="padding: 8px;">
              <b-radio v-model="scoutSet"
                :native-value="true">
                ターゲットを広く、浅く、初回訪問からスカウトを送付する
              </b-radio>
              <b-radio v-model="scoutSet"
                :native-value="false">
                ターゲットを狭く、深く、ページをじっくり見ている訪問者に対して送付する
              </b-radio>
            </div>
          </template>
          <button class="button is-primary -top-8px" @click="createNextStep()" :disabled="isMakeLoading">
            <template v-if="!isMakeLoading">次へ進む</template>
            <template v-else><span class="mdi mdi-loading mdi-spin"></span></template>
          </button>
        </div>
      </template>
      <template v-if="step === 3">
        <div class="input-box">
          <h2>ロボの作成が完了いたしました。<br>実際に作成したロボの動きを見てみましょう</h2>
          <iframe width="320" height="600" style="background: #ccc;" :src="url"/>
          <div>
            <p v-if="selectIndex === 0">※日程調整につきましては、カレンダー未連携のため本プレビューでは動作いたしません。<br>タスク予定リストをクリック後、連携しているカレンダーを選び、<br>ロボパーツ編集画面よりメンバー追加をお願い致します。<br>詳細は次のウェブセミナーのご案内よりお伝えすることを可能でございます。</p>
            <button class="button is-primary -top-8px -left-8px" @click="step=4">次へ進む</button>
          </div>
        </div>
      </template>
      <template v-if="step === 4">
        <div class="input-box">
          <h2>
            ご利用いただきまして、ありがとうございます。以上で作成が完了いたしました。
            <br>作成したロボやスカウトの修正や、更にカスタマイズして使いたい場合にはウェブセミナーに参加をお願い致します。
            <br>参加していただきますと無料トライアル期間の延長などお客様に応じた特典もご用意させていただいております。
          </h2>
          <h2>ウェブセミナーの希望日を選択してください。</h2>
          <div style="padding: 8px; width: 400px;">
            <b-radio v-model="selectDate"
              v-for="(check, idx) in dateBox" :key="idx + 'ch'"
              :native-value="check">
              {{check}}
            </b-radio>
          </div>
          <h2>ウェブセミナーの中でお聞きしたいことをご入力ください。</h2>
          <div style="padding: 8px;">
            <textarea class="textarea" v-model="bikou1"/>
          </div>
          <h2>備考</h2>
          <div style="padding: 8px;">
            <textarea class="textarea" v-model="bikou2"/>
          </div>
          <button class="button is-primary" @click="sendMessage()">送信する</button>
        </div>
      </template>
      <template v-if="step === 5">
        <div class="input-box">
          <div style="display: flex; align-items: center; font-size: 18px; font-weight 600;">
            <img style="width: 400px;" src="@/assets/template/email_rich.png"/>
            参加のお申し込みをいただきましてありがとうございました。<br>
            後日担当より、{{user.username}}様宛にEメールをお送りいたします。<br>
            （※Eメールのお送り先は{{user.email}}になります。）<br>
            引き続き、HRモンスターを宜しくお願い致します。
          </div>
          <button class="button is-primary" @click="complete()">終了し、ロボ一覧画面へ移動する</button>
        </div>
      </template>
    </div>
    <div class="begin-footer">
      <b-checkbox v-model="isNotShow">次回から表示しない</b-checkbox>
      <button class="button" @click="close()">閉じる</button>
    </div>
  </div>
</template>

<script>
import { mapState }  from 'vuex'
import * as ScenarioDate  from '@/assets/data/tutorial_scenario_date'
import * as ScenarioOubo  from '@/assets/data/tutorial_scenario_oubo'
import * as ScenarioScout from '@/assets/data/tutorial_scenario_scout'
import * as ScenarioAnke  from '@/assets/data/tutorial_scenario_anke'
import createUUID from '@/functions/createUUID'
import ModalSelectMedia from '@/components/ui/ModalSelectMedia'
export default {
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('mediapool', ['images'])
  },
  components: {
    ModalSelectMedia
  },
  data () {
    return {
      scenarioDate : ScenarioDate.scenario_date,
      scenarioOubo : ScenarioOubo.scenario_oubo,
      scenarioScout: ScenarioScout.scenario_scout,
      scenarioAnke : ScenarioAnke.scenario_anke,
      roboName: null,
      selectCol: ['お名前'],
      selectDate: null,
      isNotShow: false,
      tabIndex: 0,
      selectIndex: 0,
      step: 0,
      url: null,
      scoutSet: true,
      bikou1: null,
      bikou2: null,
      titleLists: [
        'HRモンスターで実現したいことをお選びください',
        '得たい情報・質問を次の中から選択してください',
        '設置したいホームページのURLを入力してください（URLのリンクで共有する場合は記載不要です）',
        'ロボの作成が完了いたしました。実際に作成したロボの動きを見てみましょう',
      ],
      cards: [
        {
          type: 0,
          title: '日程調整ロボを作成したい',
          img: require('@/assets/lp/issue1.png'),
          desc: '日程調整でお困りですか？早速日程調整ロボを作成して、会議や面接などをロボにお任せしてみましょう。'
        },
        {
          type: 1,
          title: '応募受付を行いたい',
          img: require('@/assets/lp/issue2.png'),
          desc: 'ホームページから自社応募を増やしたい場合には、応募受付ロボがオススメです。こちらからご確認ください。'
        },
        {
          type: 2,
          title: 'アンケートを取りたい',
          img: require('@/assets/lp/step2.png'),
          desc: '面接後にアンケートを取ることで求職者様の「隠れた心理」をヒアリングできます。'
        },
        {
          type: 3,
          title: 'ダイレクトスカウトを活用する',
          img: require('@/assets/lp/step3.png'),
          desc: 'ホームページを使い積極的に求職者へスカウトすることができます。自動で送れますので24時間365日ロボが自動で求職者にスカウトを送ることができます。'
        },
      ],
      checkBox: [
        'お名前',
        'Eメール',
        '電話番号',
        '住所',
      ],
      questions: [
        {
          text: null
        }
      ],
      urls: [
        {
          text: null
        }
      ],
      dateBox: [
        '2020-09-18（金）13:00-14:00',
        '2020-09-25（金）15:00-16:00',
        '2020-10-02（金）15:00-16:00'
      ],
      tempScout: {
        name            : null,
        type            : 0,
        category        : 1,
        scout_image_ref : null,
        catch_copy      : null,
        url             : null,
        content         : null,
        company         : null,
        story           : null,
        disp_size       : 1.5,
        reply_type      : 1
      },
      isChangingImage: false,
      autoScoutSettingSync: {
        isScout: false,
        segment: 0,
        visitedCount: 1,
        spendTime: 30,
        isConv: false
      },
      isMakeLoading: false,
    }
  },
  methods: {
    addQuestion (index) {
      // 5件以上でエラー
      if (this.questions.length > 5) {
        alert('5件以上のため追加できません。')
        return
      }
      this.questions.splice(index + 1, 0, {text: null})
    },
    delQuestion (index) {
      // 1件以下でエラー
      if (this.questions.length === 1) {
        alert('これ以上削除できません。1件目の内容も取り消したい場合は入力を空欄にしてください。')
        return
      }
      this.questions.splice(index, 1)
    },
    addURL (index) {
      // 5件以上でエラー
      if (this.urls.length > 5) {
        alert('5件以上のため追加できません。')
        return
      }
      this.urls.splice(index + 1, 0, {text: null})
    },
    delURL (index) {
      // 1件以下でエラー
      if (this.urls.length === 1) {
        alert('これ以上削除できません。1件目の内容も取り消したい場合は入力を空欄にしてください。')
        return
      }
      this.urls.splice(index, 1)
    },
    // URL/Scout設定ステップへ
    nextStepNowTwo () {
      if (this.selectIndex < 3) {
        if (!this.roboName) {
          alert('ロボ名は必ず入力してください')
          return
        }
      } else {
        if (!this.tempScout.name) {
          alert('スカウト名は必ず入力してください')
          return
        }
        if (!this.tempScout.content) {
          alert('スカウト内容は必ず入力してください')
          return
        }
      }
      this.step = 2
    },
    // ロボ作成前ステップ
    async createNextStep () {
      this.isMakeLoading = true
      await this.makeChatBot()
      if (this.selectIndex===3/*スカウト*/) this.step = 4
      else this.step = 3
      this.isMakeLoading = false
    },
    // スカウト用
    selectImage (id) {
      this.isChangingImage = true
      for (let i of this.images) {
        if (i.image_id == id) {
          this.tempScout.scout_image_ref = i.pk
          break
        }
      }
    },
    // スカウト用イメージモーダル
    openSelectModal () {
      this.$store.dispatch('mediapool/openSelectModal', {type:'image'})
    },
    // スカウトイメージ
    getImage (id, img) {
      if (this.isChangingImage) {
        if (id) {
          for (let i of this.images) {
            if (i.pk == id) return i.image_data
          }
        }
        return require('@/assets/scene/40.jpg')
      } else {
        if (img) return img
        else return require('@/assets/scene/40.jpg')
      }
    },
    // スカウト自体の作成
    createScout () {
      let createTempScout = this.tempScout
      createTempScout.company = this.user.companyPK
      this.$store.dispatch('auth/createScout', createTempScout)
        .then((d) => {
          this.setAutoScout(d.pk)
        })
    },
    // スカウト設定の作成
    setAutoScout (pk) {
      let temp = {
        parameter: this.autoScoutSettingSync,
        company: this.user.companyPK
      }
      temp.parameter.scout = pk
      temp.parameter.isScout = true
      if (this.scoutSet) {
        // とにかくスカウト
        temp.parameter.spendTime = 15
      } else {
        // しぼってスカウト
        temp.parameter.segment = 1
      }
      // 初期作成
      this.$store.dispatch('auth/createScoutAutoSending', temp)
    },
    async makeChatBot() {
      if (this.selectIndex===3/*スカウト*/) {
        this.createScout()
        this.roboName = 'お問い合わせロボ'
      }
      let scenariName = createUUID()
      let group = this.user.companyID
      let createChatBotTemp = {
        name: this.roboName,
        scenario_name: scenariName,
        group: group,
        left: 0,
        used_hours: 0,
        order_num: 0,
        is_store: false,
        editor: [this.user.userHash],
        permit_users: {
          'users': [this.user.userHash]
        }
      }
      let chatbot = await this.$store.dispatch('chatbot/createChatBot', createChatBotTemp)

      //シナリオ作成
      let tempScenarioTable = null
      if (this.selectIndex===0/*日程*/) tempScenarioTable = this.makeScenarioDate()
      else if (this.selectIndex===1/*おうぼ*/) tempScenarioTable = this.makeScenarioOubo()
      else if (this.selectIndex===2/*アンケート*/) tempScenarioTable = this.makeScenarioAnke()
      else if (this.selectIndex===3/*スカウト*/) tempScenarioTable = this.makeScenarioScout()

      await this.$store.dispatch('chatbot/importScenarioList', {scenarioName: scenariName, scenarioTable: tempScenarioTable})

      // パーツをロック
      let parts_lock = this.$store.dispatch('chatbot/scenarioPartsConfirm', {
        companyid: this.user.companyID,
        scenarioName: chatbot.scenario_name,
        flg: true
      })
      // ロボをロック
      chatbot.is_confirm = true
      let robo_lock = this.$store.dispatch('chatbot/setChatBot', chatbot)
      await Promise.all([parts_lock, robo_lock])

      // シナリオできたら次へ
      this.url = process.env.OWN_ENDPOINT + '/single/' + chatbot.group + '/' + chatbot.bot_id
    },
    // スカウト
    makeScenarioScout () {
      let tempScenarioTable = this.$_.cloneDeep(this.scenarioScout)
      // 会社名置換
      tempScenarioTable[0].mainmessage = tempScenarioTable[0].mainmessage.replace('$1', this.user.companyName)
      tempScenarioTable[5].parameter.to = this.user.email
      return tempScenarioTable
    },
    // 応募
    makeScenarioOubo () {
      let tempScenarioTable = this.$_.cloneDeep(this.scenarioOubo)
      // 会社名置換
      tempScenarioTable[0].mainmessage = tempScenarioTable[0].mainmessage.replace('$1', this.user.companyName)
      tempScenarioTable[9].parameter.to = this.user.email
      let isFirst = false
      let maxScn = tempScenarioTable.length
      let valid_questions = this.questions.filter((q) => q.text)
      for (let i = 0; i < 5; i++) {
        if (valid_questions.length > i) {
          tempScenarioTable[i+1].mainmessage = tempScenarioTable[i+1].mainmessage.replace('$Q' + Number(Number(i) + 1), valid_questions[Number(i)].text)
        } else {
          // シナリオ繋げる
          if (!isFirst) {
            tempScenarioTable[i].select[0].next_node = tempScenarioTable[6].beforenode
          }
          let num = tempScenarioTable.length - maxScn + ( i + 1 )
          tempScenarioTable.splice(num, 1)
          isFirst = true
        }
      }
      // 応募設定の変更
      this.$store.dispatch('auth/setProfile', {data: {
        subscribe_is_name: true,
        subscribe_is_email: this.$_.includes(this.selectCol, 'Eメール'),
        subscribe_is_tel: this.$_.includes(this.selectCol, '電話番号'),
        subscribe_is_address: this.$_.includes(this.selectCol, '住所'),
        subscribe_required_name: true,
        subscribe_required_email: this.$_.includes(this.selectCol, 'Eメール'),
        subscribe_required_tel: this.$_.includes(this.selectCol, '電話番号'),
        subscribe_required_address: this.$_.includes(this.selectCol, '住所'),
      },
        type: 'company'
      })
      return tempScenarioTable
    },
    // アンケート
    makeScenarioAnke () {
      let tempScenarioTable = this.$_.cloneDeep(this.scenarioAnke)
      tempScenarioTable[10].parameter.to = this.user.email
      let isFirst = false
      let maxScn = tempScenarioTable.length
      let valid_questions = this.questions.filter((q) => q.text)
      for (let i = 0; i < 5; i++) {
        if (valid_questions.length > i) {
          tempScenarioTable[i+5].mainmessage = tempScenarioTable[i+5].mainmessage.replace('$' + Number(Number(i) + 1), valid_questions[i].text)
        } else {
          // シナリオ繋げる
          if (!isFirst) {
            tempScenarioTable[i+4].select[0].next_node = tempScenarioTable[10].beforenode
          }
          let num = tempScenarioTable.length - maxScn + ( i + 5 )
          tempScenarioTable.splice(num, 1)
          isFirst = true
        }
      }
      let manlen = tempScenarioTable.length
      if (!this.$_.includes(this.selectCol, 'Eメール')) {
        tempScenarioTable[1].select[0].next_node = tempScenarioTable[3].beforenode
        tempScenarioTable.splice(2, 1)
      }
      if (!this.$_.includes(this.selectCol, '電話番号')) {
        // 減らした場合
        if (tempScenarioTable.length === manlen - 1) {
          tempScenarioTable[1].select[0].next_node = tempScenarioTable[3].beforenode
          tempScenarioTable.splice(2, 1)
        } else {
          tempScenarioTable[2].select[0].next_node = tempScenarioTable[4].beforenode
          tempScenarioTable.splice(3, 1)
        }
      }
      if (!this.$_.includes(this.selectCol, '住所')) {
        // 減らした場合
        if (tempScenarioTable.length === manlen - 2) {
          tempScenarioTable[1].select[0].next_node = tempScenarioTable[3].beforenode
          tempScenarioTable.splice(2, 1)
        } else if (tempScenarioTable.length === manlen - 1) {
          tempScenarioTable[2].select[0].next_node = tempScenarioTable[4].beforenode
          tempScenarioTable.splice(3, 1)
        } else {
          tempScenarioTable[3].select[0].next_node = tempScenarioTable[5].beforenode
          tempScenarioTable.splice(4, 1)
        }
      }
      return tempScenarioTable
    },
    // 日程
    makeScenarioDate () {
      let tempScenarioTable = this.$_.cloneDeep(this.scenarioDate)
      tempScenarioTable[11].parameter.to = this.user.email
      let isFirst = false
      let maxScn = tempScenarioTable.length
      let valid_questions = this.questions.filter((q) => q.text)
      for (let i = 0; i < 5; i++) {
        if (valid_questions.length > i) {
          tempScenarioTable[i+5].mainmessage = tempScenarioTable[i+5].mainmessage.replace('$' + Number(Number(i) + 1), valid_questions[i].text)
        } else {
          // シナリオ繋げる
          if (!isFirst) {
            tempScenarioTable[i + 4].select[0].next_node = tempScenarioTable[10].beforenode
          }
          let num = tempScenarioTable.length - maxScn + ( i + 5 )
          tempScenarioTable.splice(num, 1)
          isFirst = true
        }
      }
      let manlen = tempScenarioTable.length
      if (!this.$_.includes(this.selectCol, 'Eメール')) {
        tempScenarioTable[1].select[0].next_node = tempScenarioTable[3].beforenode
        tempScenarioTable.splice(2, 1)
      }
      if (!this.$_.includes(this.selectCol, '電話番号')) {
        // 減らした場合
        if (tempScenarioTable.length === manlen - 1) {
          tempScenarioTable[1].select[0].next_node = tempScenarioTable[3].beforenode
          tempScenarioTable.splice(2, 1)
        } else {
          tempScenarioTable[2].select[0].next_node = tempScenarioTable[4].beforenode
          tempScenarioTable.splice(3, 1)
        }
      }
      if (!this.$_.includes(this.selectCol, '住所')) {
        // 減らした場合
        if (tempScenarioTable.length === manlen - 2) {
          tempScenarioTable[1].select[0].next_node = tempScenarioTable[3].beforenode
          tempScenarioTable.splice(2, 1)
        } else if (tempScenarioTable.length === manlen - 1) {
          tempScenarioTable[2].select[0].next_node = tempScenarioTable[4].beforenode
          tempScenarioTable.splice(3, 1)
        } else {
          tempScenarioTable[3].select[0].next_node = tempScenarioTable[5].beforenode
          tempScenarioTable.splice(4, 1)
        }
      }
      return tempScenarioTable
    },
    sendMessage () {
      let isConfirm = window.confirm('こちらの内容で送付いたしますがよろしいでしょうか？')
      if (isConfirm) {
        let sendText = ''
        sendText += this.user.companyName + '<br>' + this.user.username + '様<br><br>'
        sendText += 'いつもお世話になっております。<br>HRモンスター運営事務局です。<br><br>'
        sendText += 'ウェブセミナーのご希望日時をご入力いただきまして、誠にありがとうございました。<br>'
        sendText += '下記ご希望日時で承りましたので、後日担当からメールでご案内させていただきます。<br>'
        sendText += '<br>=======================<br>'
        sendText += '▼お名前<br>'
        sendText += this.user.username + '<br>'
        sendText += '▼会社名<br>'
        sendText += this.user.companyName + '<br>'
        sendText += '▼ウェブセミナーご希望日時<br>'
        sendText += this.selectDate + '<br>'
        sendText += '▼ウェブセミナーの中でお聞きしたいことをご入力ください<br>'
        sendText += this.bikou1 + '<br>'
        sendText += '▼備考<br>'
        sendText += this.bikou2 + '<br>'
        sendText += '<br>=======================<br>'
        sendText += '<br>今後とも、何卒宜しくお願い致します。<br>HRモンスター運営事務局（sales@hr-monster.io）'
        let tempData = {
          to_email: this.user.email,
          cc_email: null,
          name: '【HRモンスター】ウェブセミナーのご希望日時を承りました',
          template: sendText
        }
        this.$store.dispatch('auth/sendEmailSeminarView', tempData)
        this.step = 5
      } else {
        alert('キャンセルいたしました')
      }
    },
    close () {
      let isMove = window.confirm('本ページを閉じますがよろしいでしょうか？')
      if (isMove) {
        if (this.isNotShow) {
          this.$store.dispatch('auth/setProfile', {data: {is_tutorial: false}, type: 'user'})
        }
        localStorage.setItem('_bfr_open', new Date().getDate())
        this.$router.push('/client/chatbot?pages=1&recruit=true')
      }
    },
    complete () {
      localStorage.setItem('_bfr_open', new Date().getDate())
      this.$store.dispatch('auth/setProfile', {data: {is_tutorial: false}, type: 'user'})
      this.$router.push('/client/chatbot?pages=1&recruit=true')
    }
  }
}
</script>

<style lang="scss" scoped>
.main-container {
  width: calc(100% - 200px);
  height: calc(100vh - 80px);
  overflow: scroll;
}
.begin-header {
  width: 100%;
  position: relative;
  h2 {
    padding: 12px 24px;
    font-size: 24px;
    font-weight: 600;
    color: #C82E42;
    width: calc(100% - 200px);
    text-align: left;
  }
  p {
    margin-left: 24px;
    padding: 12px;
    font-size: 20px;
    width: calc(100% - 200px);
    text-align: left;
    border-radius: 16px;
  }
}
.begin-main {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-left: 24px;
  h1 {
    font-size: 24px;
    font-weight: 600;
    text-align: left;
    width: 100%;
    padding: 12px 0;
  }
  .chatbot-card {
    width: 280px;
    height: 380px;
    border: solid thin #ccc;
    border-radius: 8px;
    margin: 8px;
    padding: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h2 {
      font-size: 18px;
      font-weight: 600;
    }
    button {
      width: 100%;
    }
    .card-image {
      width: 100%;
      height: 200px;
      object-fit: scale-down;
    }
    .desc {
      font-size: 14px;
      padding: 8px;
      height: 180px;
      text-align: left;
      overflow: auto;
    }
  }
  .input-box {
    text-align: left;
    padding: 16px;
    h2 {
      margin: 8px 0;
      font-weight: 600;
      font-size: 18px;
    }
    p {
      font-size: 16px;
      color: #666;
    }
  }
}
.begin-footer {
  display: flex;
  align-items: center;
  padding-right: 24px;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Tutorial/EasyMaking.vue